{
  "name": "campaigns",
  "version": "3.0.706",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:qa": "ng serve --configuration=local-qa --open",
    "start:staging": "ng serve --configuration=local-staging --open",
    "staging": "ng serve --configuration=staging --open",
    "build": "ng build",
    "build-staging": "ng build --configuration=staging",
    "build-production": "ng build --configuration=production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "nswag-cp": "node node_modules/nswag/bin/nswag.js run nswag-cp.json",
    "nswag-rw": "node node_modules/nswag/bin/nswag.js run nswag-rw.json",
    "nswag-bm": "node node_modules/nswag/bin/nswag.js run nswag-bm.json",
    "nswag-um": "node node_modules/nswag/bin/nswag.js run nswag-um.json",
    "nswag-ic": "node node_modules/nswag/bin/nswag.js run nswag-ic.json",
    "nswag-dm": "node node_modules/nswag/bin/nswag.js run nswag-dm.json",
    "nswag-am": "node node_modules/nswag/bin/nswag.js run nswag-am.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.19",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.19",
    "@angular/compiler": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^20.3.19",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.19",
    "@angular/platform-browser-dynamic": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@aws-amplify/ui-angular": "^5.1.3",
    "@ngneat/until-destroy": "^9.2.3",
    "@swimlane/ngx-datatable": "^23.0.1",
    "@tweenjs/tween.js": "^25.0.0",
    "angularx-qrcode": "^20.0.0",
    "aws-amplify": "^6.15.3",
    "chance": "^1.0.18",
    "d3": "^7.8.5",
    "date-fns": "4.1.0",
    "file-saver": "^2.0.2",
    "hammerjs": "^2.0.8",
    "jszip": "^3.2.1",
    "jszip-utils": "0.0.2",
    "luxon": "^1.16.0",
    "moment": "^2.30.1",
    "monaco-editor": "^0.52.2",
    "ngx-clipboard": "^15.1.0",
    "ngx-dropzone": "^3.1.0",
    "ngx-image-zoom": "^1.0.1",
    "ngx-mat-timepicker": "^20.0.1",
    "ngx-moment": "^6.0.2",
    "ngx-monaco-editor-v2": "^20.3.0",
    "ngx-quill": "^28.0.2",
    "parchment": "^3.0.0",
    "quill": "^2.0.3",
    "quill-mention": "^6.1.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.4.0",
    "wecheer-amplify": "file:../../../Common/Wecheer-UI/dist/wecheer-amplify",
    "wecheer-common": "file:../../../Common/Wecheer-UI/dist/wecheer-common",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.24",
    "@angular/cli": "^20.3.24",
    "@angular/compiler-cli": "^20.3.19",
    "@types/jasmine": "~3.10.0",
    "@types/node": "^12.11.1",
    "baseline-browser-mapping": "^2.8.29",
    "jasmine-core": "~4.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "nswag": "^14.7.1",
    "typescript": "^5.8.3"
  },
  "overrides": {
    "uuid": "^14.0.0"
  }
}
